import { createClient } from "@connectrpc/connect";
import {
  BaseGrpcCatalogService,
  GrpcCatalogoFetchResult,
} from "../../../../base/services/BaseGrpcCatalogService";
import { grpcTransportProvider } from "../../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../../comun/services/grpc/mapConnectError";
import {
  CatalogosMonitoreoService,
  MonitoreoPlagaEnfermedadItem,
} from "../../../../generated/grpc/catalogos_monitoreo_pb";

/** Variante gRPC-Web (con delta) de `MonitoreoPlagaEnfermedadGetCatalogService` (ver ese archivo). */
export class MonitoreoPlagaEnfermedadGrpcCatalogService extends BaseGrpcCatalogService<MonitoreoPlagaEnfermedadItem> {
  protected readonly storeName = "monitoreoPlagasEnfermedades" as const;
  protected readonly sortFieldName = "nombreComun";

  protected async fetchAsync(ultimaSincronizacion: bigint): Promise<GrpcCatalogoFetchResult<MonitoreoPlagaEnfermedadItem>> {
    const client = createClient(CatalogosMonitoreoService, grpcTransportProvider.get());

    try {
      const response = await client.listMonitoreoPlagaEnfermedades({ ultimaSincronizacion });
      return { items: response.items, timestampSincronizacion: response.timestampSincronizacion };
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}

/** Singleton del servicio gRPC del catálogo de plagas/enfermedades. */
export const monitoreoPlagaEnfermedadGrpcCatalogService = new MonitoreoPlagaEnfermedadGrpcCatalogService();
